import { colors, action, global as sharedConst } from "../shared/const";
import { localStorage } from "../shared/functions/AsyncStorage";

const global = {
    ...sharedConst,
    app_code: "dv"
}

export {
    global,
    colors,
    localStorage,
    action
}